<div class="sticky-header">
  <app-header></app-header>
  <app-alerts *ngIf="
      !rootScope.isWarningToHide ||
      !rootScope.isErrorToHide ||
      !rootScope.isInfoToHide ||
      !rootScope.isSuccessToHide||!rootScope.isGENSYSErrorToHide || !rootScope.isGensysUDPErrorToHide
    " [isWarningToHide]="rootScope.isWarningToHide" [isErrorToHide]="rootScope.isErrorToHide"
    [isInfoToHide]="rootScope.isInfoToHide" [isSuccessToHide]="rootScope.isSuccessToHide" [msg]="rootScope.alertMsg">
  </app-alerts>
</div>
<!-- Need to add a "simulation-mode" class at line no. 21 with ccr-wrapper in case of simulation mode-->

<main class="ccr-wrapper" [ngClass]="{ 'nav-with-child': rootScope.activeLink == 'search' }">
  <router-outlet *ngIf="rootScope.loadUI"></router-outlet>

  <app-loader [loaderType]="loaderType" *ngIf="loading$ | async"></app-loader>
</main>